import { Location } from '@angular/common';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { inject, Injectable } from '@angular/core';
import { DrawerRenderedRouteData } from '../interfaces/DrawerRenderedRouteData';
import { FormService } from '../../forms/services/form.service';
import { DrawerService } from '../services/drawer.service';
import { PreviousRouteService } from '../services/previous-route.service';

@Injectable({
    providedIn: 'root',
})
export class DrawerRenderedGuard {
    private router = inject(Router);
    private drawerService = inject(DrawerService);
    private formService = inject(FormService);
    private previousRouteService = inject(PreviousRouteService);
    private location = inject(Location);

    canActivate(route: ActivatedRouteSnapshot): boolean {
        const data = route.data as DrawerRenderedRouteData;

        const previousUrl = this.previousRouteService.getPreviousUrl();
        const currentUrl = this.previousRouteService.getCurrentUrl();
        const parentData = this.previousRouteService.getCurrentRouteData();

        const currentPath = this.urlPathOnly(currentUrl);
        const previousPath = this.urlPathOnly(previousUrl);
        const urlIsUnderPreviousContext =
            !!previousPath &&
            (currentPath === previousPath ||
                currentPath.startsWith(`${previousPath}/`));

        // Do not open drawer if the route is not a child of the previous route or if the entity type of the previous route is different
        if (
            !previousUrl ||
            (!urlIsUnderPreviousContext &&
                parentData?.entityType !== data.entityType)
        ) {
            this.formService.registerForm(data.entityType);
            return true;
        }

        if (!data.type || !route.component) {
            console.error(
                'Route with DrawerRenderedGuard must contain a component and DrawerRenderedRouteData'
            );
            return true;
        }

        const state = this.router.currentNavigation()?.extras.state;
        this.drawerService.createFormDrawer({
            title: data.title,
            entityType: data.entityType,
            component: route.component,
            hash: state?.['hash'],
        });
        setTimeout(() => this.location.replaceState(currentUrl));
        return false;
    }

    private urlPathOnly(url: string | undefined | null): string {
        if (!url) {
            return '';
        }
        const path = url.split(/[?#]/)[0] ?? '';
        if (path.length <= 1) {
            return path;
        }
        return path.replace(/\/+$/, '');
    }
}
